import React, {useState, useEffect, useRef} from 'react';
import {makeRequest} from "../../utils/httpRequest";
import ProductSelect from "./ProductSelect";
import ProductAvailability from "./ProductAvailability";
import {findAllProductsByQueryString} from "../../utils/requestUtils";
import Config from "../../core/config";
import {useRecoilState} from "recoil";
import {loadingAtom} from "../../atoms";
import Cookies from "js-cookie";
import {useNavigate} from "react-router-dom";

const apiUrl = Config.apiUrl;
const ProductList = () => {
        let [products, setProducts] = useState([]);
        const [queryString, setQueryString] = useState('');
        const [orderBy, setOrderBy] = useState({field: 'name', direction: 'asc'});
        const [openMenuId, setOpenMenuId] = useState(null);
        const inputQueryString = useRef(null);
        const openMenuRef = useRef(null);
        const [, setLoading] = useRecoilState(loadingAtom);
        const navigate = useNavigate();

        async function makeQuery(query) {
            try {
                setLoading(true);
                setProducts(await findAllProductsByQueryString(query));
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setLoading(false);
            }
        }

        useEffect(() => {
            if (inputQueryString.current) {
                inputQueryString.current.focus();
            }
            makeQuery('');
        }, []);

        useEffect(() => {
            function handleOutsideClick(event) {
                if (openMenuRef.current && !openMenuRef.current.contains(event.target)) {
                    setOpenMenuId(null);
                }
            }

            document.addEventListener('mousedown', handleOutsideClick);
            return () => document.removeEventListener('mousedown', handleOutsideClick);
        }, []);

        async function excluirProduto(id) {
            try {
                const url = apiUrl + '/api/products/' + id;
                await makeRequest(url, 'DELETE', {'Useruuid':Cookies.get('userUUID')});
                await makeQuery(queryString);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }

        function toggleMenu(productId) {
            setOpenMenuId((prevState) => (prevState === productId ? null : productId));
        }

        const handleInputChange = (e) => {
            const string = e.target.value;
            if (string.length >= 3 || string.length === 0) {
                makeQuery(string);
            }
            setQueryString(string);
        };

        function handleOrderBy(field) {
            setOrderBy((prevState) => {
                if (prevState.field === field) {
                    return {
                        field,
                        direction: prevState.direction === 'asc' ? 'desc' : 'asc'
                    };
                }
                return {field, direction: 'asc'};
            });
        }

        function getOrderIndicator(field) {
            if (orderBy.field !== field) {
                return '';
            }
            return orderBy.direction === 'asc' ? ' ▲' : ' ▼';
        }

        function compareValues(valueA, valueB) {
            if (typeof valueA === 'number' && typeof valueB === 'number') {
                return valueA - valueB;
            }
            if (typeof valueA === 'boolean' && typeof valueB === 'boolean') {
                return Number(valueA) - Number(valueB);
            }
            return String(valueA ?? '').localeCompare(String(valueB ?? ''), 'pt-BR', {numeric: true});
        }

        const sortedProducts = [...products].sort((a, b) => {
            const orderResult = compareValues(a[orderBy.field], b[orderBy.field]);
            return orderBy.direction === 'asc' ? orderResult : -orderResult;
        });


        return (
            <>
                <div className="header-label">Consulta de Produtos</div>

                <div
                    style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}>
                    <input ref={inputQueryString} type="text" value={queryString} onChange={handleInputChange}/>
                    <button onClick={() => navigate('/product')}>Novo</button>                </div>
                <table className="product-list-table" style={{width: '480px'}}>
                    <colgroup>
                        <col style={{width: '60px'}}/>
                        <col/>
                        <col style={{width: '75px'}}/>
                        <col style={{width: '40px'}}/>
                    </colgroup>
                    <tr>
                        <th onClick={() => handleOrderBy('code')} style={{cursor: 'pointer'}}>
                            Código{getOrderIndicator('code')}
                        </th>
                        <th onClick={() => handleOrderBy('name')} style={{cursor: 'pointer'}}>
                            Nome{getOrderIndicator('name')}
                        </th>
                        <th onClick={() => handleOrderBy('salePrice')} style={{cursor: 'pointer'}}>
                            Preço{getOrderIndicator('salePrice')}
                        </th>
                        <th/>
                    </tr>
                    <tbody style={{overflowY: 'auto'}}>
                    {sortedProducts.map((product, index) => (

                        <tr key={index}>
                            <td>
                                <div>{product.code}</div>
                            </td>
                            <td>
                                <div className="product-name-cell">{product.name}</div>
                            </td>
                            <td>
                                <div style={{textAlign: 'right'}}>{product.salePrice.toLocaleString('pt-BR', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                })}
                                </div>
                            </td>
                            <td>
                                <div
                                    className="kebab-menu-container"
                                    ref={openMenuId === product.id ? openMenuRef : null}
                                >
                                    <button
                                        className="kebab-menu-button"
                                        onClick={() => toggleMenu(product.id)}
                                        aria-label="Ações"
                                    >
                                        ⋮
                                    </button>
                                    {openMenuId === product.id && (
                                        <ul className="kebab-menu">
                                            <li>
                                                <button
                                                    className="kebab-menu-item"
                                                    onClick={async () => {
                                                        setOpenMenuId(null);
                                                        await navigate('/product?id=' + product.id);
                                                    }}
                                                >
                                                    Editar
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    className="kebab-menu-item remove-button"
                                                    onClick={async () => {
                                                        setOpenMenuId(null);
                                                        // eslint-disable-next-line no-restricted-globals
                                                        if (window.confirm('Deseja realmente excluir?')) {
                                                            await excluirProduto(product.id);
                                                        }
                                                    }}
                                                >
                                                    Excluir
                                                </button>
                                            </li>
                                        </ul>
                                    )}
                                </div>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                    {products.length === 0 && (<tfoot>Nenhum item encontrado.</tfoot>)}
                </table>
            </>
        );
    }
;

export default ProductList;
